module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAMAAABSrFY3AAAAQlBMVEWZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZlTX8olAAAAFXRSTlMAAQYJDBgbZ2hsq6yxsrPV1tjZ6v4ZKx1zAAAAXUlEQVQY03XORw6AMAxEUWNq6CW+/1WJHBShif13o7cZIqOGnHgODiwSgwNikoLI1TpwD/gFYNzYhinKzg5IJgA+dCYCIOrPTB1CoaeCQjX8CKFQDR9ZoGRDohXgBb1QCx2zqfhiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/score-board-check.png
// module id = 379
// module chunks = 0